import { initToast } from "GlobalActionCreator/Toast";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";
import { SCREEN } from "../constants/Global";
import ForgotPassword from "../containers/ForgotPassword";
import Login from "../containers/Login";
import SignUp from "../containers/SignUp";
import { platform } from "GlobalEnum/Platform";

const propTypes = {
  /** Used to render current screen content */
  screen: PropTypes.oneOf(
    Object.keys(SCREEN).map(key => {
      return SCREEN[key];
    })
  ).isRequired,
};

/**
 * This component renders the content inside account popup
 * based on screen type and handles display of toast on user actions
 */
export const PopupContent = ({ screen, accountRef }) => {
  const dispatch = useDispatch();

  function showToast(message) {
    const style = {};
    if (accountRef && accountRef.current) {
      const viewPortHeight = window.innerHeight || 0;
      const popupHeight = accountRef.current.offsetHeight;
      const popupTop = accountRef.current.getBoundingClientRect().top;
      const toastPosition = viewPortHeight - popupHeight - popupTop + 100;
      style.bottom = toastPosition;
    }
    dispatch(
      initToast({
        message,
        style,
      })
    );
  }

  switch (screen) {
    case SCREEN.SIGN_UP:
      return <SignUp showToast={showToast} platForm={platform.DESKTOP} />;
    case SCREEN.LOG_IN:
      return <Login showToast={showToast} platForm={platform.DESKTOP} />;
    case SCREEN.FORGOT_PASSWORD:
      return (
        <ForgotPassword showToast={showToast} platForm={platform.DESKTOP} />
      );
    default:
      return null;
  }
};
PopupContent.propTypes = propTypes;
